module.exports = __webpack_public_path__ + "static/media/business_640_color.2ecbdbfe.png";